// extracted by mini-css-extract-plugin
export default {"tooltipIcon":"Tooltip_tooltipIcon__6JhRH","tooltipWrapper":"Tooltip_tooltipWrapper__1kPjO","tooltipPopup":"Tooltip_tooltipPopup__M3BpH","tip":"Tooltip_tip__GPJrS"};